import ApiService from "@/services/Api"
import ErrorHandlerService from "@/services/ErrorHandler"

import { Tag } from "@/protocols/tag"
import { ErrorType } from "@/hooks/useValidation"

export type TagSearchQuery = {
	tagName: string
}

export type TagUpdateData = {
	name?: string
	description?: string
}

class TagService {
	async getTags (searchQuery?: TagSearchQuery): Promise<Tag[] | null> {
		try {
			const { data } = await ApiService.get("/tag", {
				params: {
					tag_name: searchQuery?.tagName
				}
			})

			return data.tags
		} catch (error) {
			ErrorHandlerService.handle(error as ErrorType)
			return null
		}
	}

	async update (tagId: number, data: TagUpdateData): Promise<Tag | null> {
		try {
			const { data: tag } = await ApiService.put(`/tag/${tagId}`, data)

			return tag
		} catch (error) {
			ErrorHandlerService.handle(error as ErrorType)
			return null
		}
	}
}

export default new TagService()
